import PropTypes from 'prop-types';
import './LocationProgramPointList.scss';

const LocationTitle = ({ pozoNombre, eventoSigla, nombreEquipo }) => {
  if (pozoNombre || eventoSigla || nombreEquipo) {
    return (
      <div className="d-flex gap-4 align-items-center title-container">
        <span className="fw-bold">Ubicación</span>
        <div className="d-flex gap-4 align-items-center">
          <span className="fw-bold">{pozoNombre}</span>
          <span className="pill fw-bold">{eventoSigla}</span>
          <span className="fw-bold">{nombreEquipo}</span>
        </div>
      </div>
    );
  }

  return null;
};

LocationTitle.propTypes = {
  pozoNombre: PropTypes.string,
  eventoSigla: PropTypes.string,
  nombreEquipo: PropTypes.string
};

LocationTitle.defaultProps = {
  pozoNombre: null,
  eventoSigla: null,
  nombreEquipo: null
};

export default LocationTitle;
